import styled from 'styled-components';
import { fullWidthKeys, fullWidthMixin } from '../../mixins/layout';
import { withOmitProps } from '../../helpers/elements';
const ButtonContainer = styled.span.withConfig(withOmitProps([...fullWidthKeys]))`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  ${fullWidthMixin}
`;
export default ButtonContainer;